export default __webpack_public_path__ + "static/media/z_wdt_c_3.f61c8af6.mp3";